/** Dépôts ISC distincts pour le tenant demo-hospitol. */
import { routes } from "@/router/all_routes";

export type StockDepotId = "pharmacy" | "consumables";

export interface StockDepotConfig {
  id: StockDepotId;
  label: string;
  shortLabel: string;
  storeCode: string;
  categoryCodes: string[];
  receiptReference: string;
}

export const STOCK_DEPOTS: Record<StockDepotId, StockDepotConfig> = {
  pharmacy: {
    id: "pharmacy",
    label: "Médicaments (officine)",
    shortLabel: "Médicaments",
    storeCode: "WH-PHARMA",
    categoryCodes: ["PHARMA"],
    receiptReference: "HOSPITOL-PHARMA-RECEIPT",
  },
  consumables: {
    id: "consumables",
    label: "Consommables & labo",
    shortLabel: "Consommables",
    storeCode: "WH-CONS",
    categoryCodes: ["CONS", "LAB"],
    receiptReference: "HOSPITOL-CONS-RECEIPT",
  },
};

export function isPharmacyProduct(categoryCode?: string): boolean {
  return categoryCode === "PHARMA";
}

export function productMatchesDepot(
  categoryCode: string | undefined,
  depot: StockDepotId,
): boolean {
  if (!categoryCode) return depot === "consumables";
  return STOCK_DEPOTS[depot].categoryCodes.includes(categoryCode);
}

export function depotSupplyRoutes(depot: StockDepotId) {
  if (depot === "pharmacy") {
    return {
      articles: routes.supplyMedicinesArticles,
      levels: routes.supplyMedicinesLevels,
      receipts: routes.supplyMedicinesReceipts,
      receiptsHistory: routes.supplyMedicinesReceiptsHistory,
    };
  }
  return {
    articles: routes.supplyConsumablesArticles,
    levels: routes.supplyConsumablesLevels,
    receipts: routes.supplyConsumablesReceipts,
    receiptsHistory: routes.supplyConsumablesReceiptsHistory,
  };
}
